let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lSLEp")).then(() => parcelRequire('8kPOi'));